import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import tabletInfoGenesis from '../assets/products/tablet-info-genesis.png';
import flyTapPayTall from '../assets/products/fly-tap-pay-tall.png';
import appOndemandFoodTall from '../assets/products/app-ondemand-food-tall.png';
import appQrQuickpayTall from '../assets/products/app-qr-quickpay-tall.png';
import appReservePickleball from '../assets/products/app-reserve-pickleball-tall.png';

const PickleballPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page splash pickleballPage">
      <div className="background" />
      <Header />
      <div className="page-header">Pickleball Courts</div>

      <div className="text-blocks">
        <div className="std-text">
          {"Serve up a winning player experience. Whether it's booking a court time, scheduling a lesson or providing courtside refreshments, you need\u00a0a flexible, configurable solution that seamlessly integrates with your POS solution and adds court reservations to a common resident\u00a0itinerary.\u00a0"}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="InfoGenesis"
          imgSrc={tabletInfoGenesis}
          onClick={() => navigate('/solutions/info-genesis')}
        />
        <FeaturedItem
          label="IG Fly"
          imgSrc={flyTapPayTall}
          onClick={() => navigate('/solutions/ig-fly')}
        />
        <FeaturedItem
          label="IG OnDemand"
          imgSrc={appOndemandFoodTall}
          onClick={() => navigate('/solutions/ig-on-demand')}
        />
        <FeaturedItem
          label="IG Quick Pay"
          imgSrc={appQrQuickpayTall}
          onClick={() => navigate('/solutions/ig-quick-pay')}
        />
        <FeaturedItem
          label="Reserve"
          imgSrc={appReservePickleball}
          onClick={() => navigate('/solutions/reserve')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default PickleballPage;
